export function getRegistration() {
  return navigator.serviceWorker.getRegistration().then((reg) => {
    if (!reg) {
      throw new Error('no service worker registration');
    }
    return reg;
  });
}
